import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-roster-export-dialog',
  templateUrl: './roster-export-dialog.component.html',
  styleUrls: ['./roster-export-dialog.component.scss'],
  standalone: false
})
export class RosterExportDialogComponent implements OnInit {
  selectedType: number = 1;
  userType: string = 'SHOP';

  exportTypes = [
    { value: 1, label: 'Forecast for manager', isManager: true },
    { value: 6, label: 'Actual for manager', isManager: true },
    { value: 2, label: 'Forecast and actual for manager', isManager: true },
    { value: 3, label: 'Forecast for staff', isManager: false },
    { value: 5, label: 'Actual for staff', isManager: false },
    { value: 4, label: 'Forecast and actual for staff', isManager: false }
  ];

  constructor(
    public dialogRef: MatDialogRef<RosterExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.userType = data.userType || 'SHOP';
    this.selectedType = 1; // Default to 'Forecast for manager'
  }

  ngOnInit(): void {}

  get filteredExportTypes() {
    return this.exportTypes;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    this.dialogRef.close(this.selectedType);
  }
}
